// Single swappable config value for where waitlist submissions are sent.
// Point this at a Google Sheet / webhook proxy later without touching the form.
export const WAITLIST_ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/waitlist`;
export const WAITLIST_COUNT_ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/waitlist/count`;
